import LawsInput from './LawsInput'

export default LawsInput
